import React, { Component } from 'react';

class Searchfield extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInputFocused: false,
    };
  }
  onBlurSearchInput() {
    this.setState({
      searchInputFocused: false,
    });
  }

  onFocusSearchInput() {
    this.setState({
      searchInputFocused: true,
    });
  }
  render() {
    return (
      <div className="pcoded-header w-100">
        <div className="main-search open m-2" style={{ width: '100%' }}>
          <div className={`input-group ${this.state.searchInputFocused ? `blue-border-without-shadow-attr` : ``}`}>
            <input
              disabled={this.props.disabled}
              autoFocus
              type="text"
              className="form-control input"
              placeholder={this.props.placeholder || "Search"}
              onFocus={() => this.onFocusSearchInput()}
              onBlur={() => this.onBlurSearchInput()}
              value={this.props.inputValue}
              onChange={e => this.props.inputChange(e)}
            />
            <span onClick={this.props.inputClear} class="input-group-append search-close pointer">
              <i class="feather icon-x input-group-text" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Searchfield;
